import React from "react"


export const Forms = {
    myPerfil: [
        {
            label: 'Información de usuario',
            type: 'header',
            colm: 12,
            class: 'header-card'
        },
        {
            label: 'Nombre',
            type: 'info',
            id: 'Nombre',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: true,
        },
        {
            label: 'Apellidos',
            type: 'info',
            id: 'Apellido',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: true,
        },
        {
            label: 'Correo',
            type: 'info',
            id: 'Email',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: false,
        },
        {
            label: 'Rol',
            type: 'info',
            id: 'Rol',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: false,
        },
        {
            label: 'Posición',
            type: 'info',
            id: 'Posicion',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: true,
        },
        {
            label: 'Teléfono',
            type: 'info',
            id: 'Telefono',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: true,
        },
        {
            label: 'Cambiar contraseña',
            type: 'info',
            id: 'Password',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: true,
            iconHelp: 'fas fa-info-circle custom-help',
            condiciones: (<>
                <span>La contraseña tiene una vigencia de 60 días y debe estar compuesta por:</span>
                <ul>
                    <li>• Longitud mínima de 12 caracteres</li>
                    <li>• Agregar al menos un número</li>
                    <li>• Al menos una letra mayúscula y una minúscula</li>
                    <li>• Un carácter especial (*!$%&?)</li>
                </ul>
            </>
            ),
        },
        {
            label: 'Confirmar contraseña',
            type: 'info',
            id: 'confirmPassword',
            xs: 6,
            sm: 6,
            md: 6,
            lg: 4,
            xl: 3,
            editable: true,
            iconHelp: 'fas fa-info-circle custom-help',
            condiciones: (<>
                <span>La contraseña tiene una vigencia de 60 días y debe estar compuesta por:</span>
                <ul>
                    <li>• Longitud mínima de 12 caracteres</li>
                    <li>• Agregar al menos un número</li>
                    <li>• Al menos una letra mayúscula y una minúscula</li>
                    <li>• Un carácter especial (*!$%&?)</li>
                </ul>
            </>
            ),
        },
    ]

}